/* Publish by EComposer at 2025-08-06 07:29:28*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-k3fsjai4sfb"]=  window.__ectimmers["ecom-k3fsjai4sfb"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-k3fsjai4sfb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k3fsjai4sfb', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5dco6bfk0h6"]=  window.__ectimmers["ecom-5dco6bfk0h6"] || {};
var t;if(!this.$el)return;const e=this.$el;if(this.settings.style==="slider"){let i=e.querySelector(".ecom-swiper-container"),s=i&&i.dataset.optionSwiper;if(!s)return;let l="bullets";this.settings.slider_pagination_style==="progress"&&(l="progressbar"),s=JSON.parse(s),s.pagination={el:e.querySelector(".ecom-swiper-pagination"),type:l,clickable:!0},s.navigation={nextEl:e.querySelector(".ecom-swiper-button-next"),prevEl:e.querySelector(".ecom-swiper-button-prev")},s.autoHeight=!1,s.spaceBetween=(t=this.settings.slider_spacing)!=null?t:25,window.EComSwiper&&new window.EComSwiper(i,s)}

                    });
                    
                        document.querySelectorAll('.ecom-5dco6bfk0h6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5dco6bfk0h6', settings: {"style":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}